import React, { Fragment, type PropsWithChildren, type FC } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { BreadcrumbManager } from '@atlassian/jira-breadcrumbs/src/breadcrumb-manager/index.tsx';
import { LayoutManager } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/containers/layout-manager/index.tsx';
import { ClientUiManagers as ClientUiManagersComponent } from './client-ui-managers/index.tsx';
import type { UiManagersProps } from './types.tsx';

const Filler: FC<{ for: string }> = () => null;
const Nest = ({ children }: PropsWithChildren) => <>{children}</>;

const ClientManagerServerVersion = ({ children }: PropsWithChildren) => (
	<Nest>
		<Nest>
			<Filler for="SpotLightMaanger" />
			<Nest>
				<Nest>
					{children}
					<Filler for="ModalContextProvider" />
				</Nest>
				<Filler for="FlagsProvider" />
			</Nest>
		</Nest>
		<Filler for="CrossFlowProvider" />
	</Nest>
);

/**
 * If your component or data provider is not being used inside SSR,
 * put it into `NonCriticalUiManager`, only browser will run those
 * code.
 */
export const UiManagers = ({ children }: UiManagersProps) => {
	// eslint-disable-next-line no-nested-ternary
	const ClientUiManagers = !__SERVER__
		? ClientUiManagersComponent
		: fg('jfp_magma_jira-use-id-sync')
			? ClientManagerServerVersion
			: Fragment;

	return (
		<LayoutManager>
			<BreadcrumbManager>
				<ClientUiManagers>{children}</ClientUiManagers>
			</BreadcrumbManager>
		</LayoutManager>
	);
};
